module.exports = __webpack_public_path__ + "static/img/wechat.14fb3f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/hover/wechat.png
// module id = roKC
// module chunks = 0